import { render } from "./AuthorizedContactsList.vue?vue&type=template&id=08a063bb&ts=true"
import script from "./AuthorizedContactsList.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContactsList.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__